import { Routes } from '@angular/router';
import {
    authGuard,
    hasHomeAreaGuard,
    hasNoHomeAreaGuard,
    hasNoProfessionGuard,
    hasNoReloginRequiredGuard,
    hasProfessionGuard,
    hasReloginRequiredGuard,
    isAdminGuard,
    isDisallowedToSeeBoardLandingGuard,
    shouldSeeBoardLandingGuard,
    subscriptionInvalidGuard,
    subscriptionValidGuard,
    tosPpInvalidGuard,
    tosPpValidGuard,
    unAuthGuard,
} from './core/auth/guards';


export const routes: Routes = [
    {
        path: 'dashboard',
        title: 'Dashboard',
        canActivate: [
            authGuard,
            subscriptionValidGuard,
            shouldSeeBoardLandingGuard,
            tosPpValidGuard,
            hasHomeAreaGuard,
            hasProfessionGuard,
            hasReloginRequiredGuard,
        ],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./core/dashboard-page').then(m => m.DashboardPageModuleWithRoutes),
    },
    {
        path: 'payment',
        title: 'Payment',
        canActivate: [
            subscriptionInvalidGuard,
        ],
        loadChildren: () => import('./core/support').then(m => m.ContactSupportPageModule),
    },
    {
        path: 'my-profession',
        title: 'My Profession',
        canActivate: [
            authGuard,
            hasNoProfessionGuard,
        ],
        loadChildren: () => import('./core/my-profession').then(m => m.MyProfessionModule),
    },
    {
        path: 'my-home-area',
        title: 'My Home Area',
        canActivate: [
            authGuard,
            hasNoHomeAreaGuard,
        ],
        loadComponent: () => import('./core/my-home-area/my-home-area-page.component').then(m => m.MyHomeAreaPageComponent),
    },
    {
        path: 'terms-of-services',
        title: 'Terms of Services',
        canActivate: [
            authGuard,
            tosPpInvalidGuard,
        ],
        loadComponent: () => import('./core/tos-pp/tos-pp-page.component').then(m => m.TosPpPageComponent),
    },
    {
        path: 'relogin',
        title: 'Re-Login Required',
        canActivate: [
            authGuard,
            hasNoReloginRequiredGuard,
        ],
        loadComponent: () => import('./core/relogin-page/relogin-page.component').then(m => m.ReloginPageComponent),
    },
    {
        path: 'welcome',
        canActivate: [
            authGuard,
            isDisallowedToSeeBoardLandingGuard,
        ],
        loadComponent: () => import('./core/board-landing/board-landing-page.component').then(m => m.BoardLandingPageComponent),
    },
    {
        path: 'login',
        title: 'Login',
        canActivate: [
            unAuthGuard,
        ],
        loadComponent: () => import('./core/login-page/login-page.component').then(m => m.LoginPageComponent),
    },
    {
        path: 'monitor',
        title: 'Monitor',
        canActivate: [
            authGuard,
            isAdminGuard,
        ],
        loadChildren: () => import('./core/monitor').then(m => m.MonitorModule),
    },
    {
        path: 'forgot-password',
        title: 'Forgot Password',
        loadComponent: () => import('./core/login-page/forgot-password-page.component').then(m => m.ForgotPasswordPageComponent),
    },
    {
        path: 'authorize',
        canActivate: [
            authGuard,
        ],
        loadComponent: () => import('./core/authorize-page.component').then(m => m.AuthorizePageComponent),
    },
    {
        path: 'bc-mls',
        loadComponent: () => import('./core/bc-mls-bridge/bc-mls-bridge-page.component').then(m => m.BcMlsBridgePageComponent),
    },
    {
        path: 'crea-bridge',
        loadComponent: () => import('./core/crea-bridge/crea-bridge-page.component').then(m => m.CreaBridgePageComponent),
    },
    {
        path: 'relevate-bridge',
        loadComponent: () => import('./core/relevate-bridge/relevate-bridge-page.component').then(m => m.RelevateBridgePageComponent),
    },
    {
        path: 'cma',
        loadChildren: () => import('./core/cma/share.module').then(m => m.CmaShareModule),
    },
    {
        path: '**',
        redirectTo: 'dashboard',
    },
];
